import ScalarIconTrash_vue_vue_type_script_setup_true_lang_default from "./ScalarIconTrash.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconTrash.vue
var ScalarIconTrash_default = ScalarIconTrash_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconTrash_default as default };

//# sourceMappingURL=ScalarIconTrash.js.map